import * as React from "react";
import MuiDialogTitle, {
    DialogTitleProps as MuiDialogTitleProps,
    DialogTitleClassKey as MuiDialogTitleClassKey
} from "@material-ui/core/DialogTitle";

export type DialogTitleClassKey = MuiDialogTitleClassKey;

export interface DialogTitleProps extends MuiDialogTitleProps { }

class DialogTitle extends React.PureComponent<DialogTitleProps> {
    render() {
        const { ...props } = this.props;
        return <MuiDialogTitle {...props}>
            {this.props.children}
        </MuiDialogTitle>;
    }
}

export default DialogTitle;